import React from 'react';
import AppModal from './AppModal';

type AlertConfirmModalProps = {
  show: boolean;
  mode: 'alert' | 'confirm';
  title: string;
  message: string;
  extraContent?: React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'primary' | 'danger' | 'warning' | 'secondary';
  busy?: boolean;
};

const AlertConfirmModal: React.FC<AlertConfirmModalProps> = ({
  show,
  mode,
  title,
  message,
  extraContent,
  onClose,
  onConfirm,
  confirmLabel,
  cancelLabel = 'Cancelar',
  confirmVariant = 'primary',
  busy = false
}) => {
  const confirmClass =
    confirmVariant === 'danger'
      ? 'btn btn-danger'
      : confirmVariant === 'warning'
        ? 'btn btn-warning'
        : confirmVariant === 'secondary'
          ? 'btn btn-secondary'
          : 'btn btn-primary';

  return (
    <AppModal
      show={show}
      title={title}
      onClose={onClose}
      closeDisabled={busy}
      size="md"
      footer={(
        <>
          {mode === 'confirm' && (
            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={busy}>
              {cancelLabel}
            </button>
          )}
          <button type="button" className={confirmClass} onClick={onConfirm || onClose} disabled={busy}>
            {confirmLabel || (mode === 'confirm' ? 'Confirmar' : 'OK')}
          </button>
        </>
      )}
    >
      <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>{message}</p>
      {extraContent ? <div className="mt-3">{extraContent}</div> : null}
    </AppModal>
  );
};

export default AlertConfirmModal;
